import { BaseBroadcast } from "./BaseBroadcast";

type DataType = {
    id: number
}

export class ChatMessageDeletedBroadcast extends BaseBroadcast {
    isPrivate = true;
    event = 'chat.message.deleted';
    callback: (data: DataType) => void;

    constructor(callback: (data: DataType) => void) {
        super();
        this.setCallback(callback);
    }
}
